import React from "react";
import { Modal, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { modalBackdrop } from "../../../../../theme";

interface ChartModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const ChartModal: React.FC<ChartModalProps> = ({ open, onClose, children }) => {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
      slotProps={{
        backdrop: {
          sx: modalBackdrop,
        },
      }}
    >
      <Box
        sx={{
          width: "90vw",
          height: "90vh",
          position: "relative",
          overflow: "hidden",
          backgroundColor: theme.palette.background.paper,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {children}
        </Box>

      </Box>
    </Modal>
  );
};

export default ChartModal;
